export const isArraysNotEqual = (arr1, arr2) => {
  return JSON.stringify(arr1) !== JSON.stringify(arr2);
};

export const singleUnitName = (unitsName) => {
  if (!unitsName) {
    return 'unit';
  }

  const lastLetter = unitsName.slice(-1);
  return lastLetter === 's'
    ? unitsName.slice(0, unitsName.length - 1)
    : unitsName;
};

export const addCountryCode = (telephone) => {
  const telephoneWithCode = telephone?.length === 10 ? `1${telephone}` : telephone;
  return telephoneWithCode || '';
};
